import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import Text from "components/layout/Text";

import { IShortcutListItem } from "./shortcutsList";

const Key: FC<{ keyName: string }> = ({ keyName }) => (
  <Flex
    padding="8px"
    justifyContent="center"
    alignItems="center"
    borderRadius="4px"
    border={`1px solid var(${DesignToken.BorderBasicTertiary})`}
  >
    <Text fontSize="15px" lineHeight="22px" minWidth="22px" textAlign="center">
      {keyName}
    </Text>
  </Flex>
);

const Plus: FC = () => (
  <Text fontSize="15px" lineHeight="22px">
    +
  </Text>
);

const ShortcutsItem: FC<IShortcutListItem> = ({ label, firstKey, secondKey, thirdKey }) => (
  <Flex alignItems="center" gap="16px">
    <Flex gap="8px" alignItems="center">
      <Key keyName={firstKey} />
      {secondKey && (
        <>
          <Plus />
          <Key keyName={secondKey} />
        </>
      )}
      {thirdKey && (
        <>
          <Plus />
          <Key keyName={thirdKey} />
        </>
      )}
    </Flex>
    <Text>{label}</Text>
  </Flex>
);

export default ShortcutsItem;
